export default __webpack_public_path__ + "static/media/facebook.e069b0fd.svg";